
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { app } from "../firebase-config.js";

import { parseMarkdown } from "../utils/markdown.js";

const db = getFirestore(app);

export const MarkdownModal = {
    show: async (docId, title) => {
        // Overlay (Behind Header)
        const overlay = document.createElement('div');
        overlay.className = "fixed inset-0 bg-black/60 z-[9990] fade-in backdrop-blur-sm";

        // Modal Wrapper (Top Layer)
        const wrapper = document.createElement('div');
        wrapper.className = "fixed inset-0 z-[10001] flex items-center justify-center pointer-events-none p-4";

        const modal = document.createElement('div');
        modal.className = "bg-white dark:bg-zinc-900 w-full max-w-2xl h-[80vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden animate-slide-up pointer-events-auto";

        // Header
        modal.innerHTML = `
            <div class="px-5 py-4 border-b border-zinc-100 dark:border-zinc-800 flex justify-between items-center bg-white dark:bg-zinc-900 sticky top-0 z-10">
                <h3 class="font-bold text-lg text-zinc-900 dark:text-zinc-100 flex items-center gap-2">
                    <span class="material-symbols-outlined text-zinc-500">article</span>
                    ${title}
                </h3>
                <button id="btn-close-md" class="p-2 -mr-2 text-zinc-400 hover:text-zinc-600 dark:hover:text-zinc-200 rounded-full hover:bg-zinc-100 dark:hover:bg-zinc-800 transition-colors">
                    <span class="material-symbols-outlined text-xl">close</span>
                </button>
            </div>
            <div id="md-content" class="flex-1 overflow-y-auto p-6 md:p-8 bg-white dark:bg-zinc-900 leading-relaxed font-sans">
                <div class="flex flex-col items-center justify-center h-40 text-gray-400 gap-2">
                    <span class="loader-spin w-6 h-6 border-zinc-300 border-t-blue-500"></span>
                </div>
            </div>
        `;

        wrapper.appendChild(modal);
        document.body.appendChild(overlay);
        document.body.appendChild(wrapper);

        // Close handlers
        const close = () => {
            overlay.classList.add('opacity-0');
            modal.classList.add('translate-y-4', 'opacity-0');
            setTimeout(() => {
                if (overlay.isConnected) overlay.remove();
                if (wrapper.isConnected) wrapper.remove();
            }, 300);
        };

        overlay.onclick = (e) => {
            close();
        };
        modal.querySelector('#btn-close-md').onclick = close;

        const contentContainer = modal.querySelector('#md-content');

        try {
            const docRef = doc(db, 'system_docs', docId);
            const snap = await getDoc(docRef);

            if (snap.exists()) {
                const text = snap.data().content || '';
                // [Use Shared Module]
                contentContainer.innerHTML = parseMarkdown(text);
            } else {
                contentContainer.innerHTML = `
                    <div class="flex flex-col items-center justify-center h-full text-zinc-400">
                        <span class="material-symbols-outlined text-4xl mb-2 opacity-20">description</span>
                        <span class="text-center">아직 작성된 내용이 없습니다.<br>관리자에게 문의해주세요.</span>
                    </div>
                `;
            }
        } catch (e) {
            console.error(e);
            contentContainer.innerHTML = '<div class="text-center text-red-500 py-10">내용을 불러오지 못했습니다.</div>';
        }
    }
};

